import {requestAction} from 'core/redux/helpers';
import {TAppThunk} from 'core/redux/types';
import {TProductResponse} from 'modules/product-card/models/ProductResponse';
import {TProductDeliveryInfoResponse} from 'modules/product-card/services/ProductDeliveryInfoResponse';
import {actionSetProductDeliveryInfo} from 'modules/product-card/slice';
import {actionSetCurrentProduct} from 'modules/product-card/slice';
import {ProductDetail} from 'new-models';

export const getProduct =
    (productId: ProductDetail['id']): TAppThunk<TProductResponse['data'] | undefined> =>
    async (dispatch, _, {productCardService}) => {
        const data = await dispatch(
            requestAction<TProductResponse>({
                requestCb: () => productCardService.getProduct(productId),
                type: actionSetCurrentProduct.type,
            })
        );

        dispatch(actionSetCurrentProduct(data));

        return data;
    };

export const getDeliveryInfo =
    (locationId: string, productIds?: ProductDetail['id'][] | null): TAppThunk<void> =>
    async (dispatch, _, {productCardService}) => {
        const data = await dispatch(
            requestAction<TProductDeliveryInfoResponse>({
                requestCb: () => productCardService.getDeliveryInfo(locationId, productIds),
                type: actionSetProductDeliveryInfo.type,
            })
        );

        const {deliveries} = data || {};

        dispatch(actionSetProductDeliveryInfo(deliveries));
    };
